import { render, staticRenderFns } from "./rightBottom.vue?vue&type=template&id=1a802bcc&scoped=true&"
import script from "./rightBottom.vue?vue&type=script&lang=js&"
export * from "./rightBottom.vue?vue&type=script&lang=js&"
import style0 from "./rightBottom.vue?vue&type=style&index=0&id=1a802bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a802bcc",
  null
  
)

export default component.exports